export const NAMESPACE = 'KanBo/Card/documentListItems/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_BY_URL = NAMESPACE + 'SET_BY_URL'

const initialState = {}

const documentDefaults = {
  id: null,
  url: '',
  lastModificationTimestamp: null,
  canRead: true,
  exists: true,
  thumbnailUrl: null,
  actions: [],
  isLoaded: true,
  isLoading: false,
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case ADD:
      return {
        ...state,
        [action.payload.id]: {
          ...documentDefaults,
          ...state[action.payload.id],
          ...action.payload
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state
      }
      action.payload.forEach(item => {
        newState[item.id] = {
          ...documentDefaults,
          ...state[item.id],
          ...item
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state
      }
      delete newState[action.payload.id]
      return newState
    }
    case SET_BY_URL: {
      const key =
        Object.keys(state)
          .find(key =>
            state[key].url === action.payload.url &&
            state[key].sourceId === action.payload.documentSourceId
          )

      if (key) {
        return {
          ...state,
          [key]: {
            ...documentDefaults,
            ...state[key],
            ...action.payload.data,
            url: action.payload.newUrl || state[key].url,
          }
        }
      }

      return state
    }
    default: return state
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (array) {
  return {
    type: ADD_ARRAY,
    payload: array
  }
}

export function remove (id) {
  return {
    type: REMOVE,
    payload: id
  }
}

export function setByUrl ({ documentSourceId, url, newUrl, ...data }) {
  return {
    type: SET_BY_URL,
    payload: {
      url,
      newUrl,
      documentSourceId,
      data,
    }
  }
}
